import moment from 'moment'

export const data = () => ({
  isDebug: true,
  loading: false,
  toggle: false,
  directoryContactList: [],
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: false
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'displayName',
      label: 'Name',
      aria: 'Name',
      width: '20%',
      sortable: true,
      searchable: true
    },
    {
      field: 'address',
      label: 'Address',
      aria: 'Address',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'email',
      label: 'E-mail',
      aria: 'E-mail',
      width: '30%',
      sortable: true,
      searchable: true
    },
    {
      field: 'phone',
      label: 'Phone',
      aria: 'Phone',
      width: '30%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    dateSelector: {
      display: 'flex',
      padding: '12px',
      textAlign: 'center',
      verticalAlign: 'middle',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-end'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    }
  }
})
